import React from 'react';
import ArticleCardBase from '../../Base';

import './styles.scss';

const SquareNumberLarge4 = ({ data, endCard }) => {
  const { backgroundColor, barColor, paragraphC24, header, number } = data;
  const stripNumber = number.replace(/(<([^>]+)>)/gi, '');
  const numberTextClass = stripNumber.length >= 4 ? 'square-number-large-4__number--resized' : '';

  return (
    <ArticleCardBase variation="square" accentColor1={backgroundColor} endCard={endCard}>
      <section className="card-container square-number-large-4">
        <div
          className={`square-number-large-4__number ${numberTextClass}`}
          dangerouslySetInnerHTML={{ __html: number }}
        />
        <span className="square-number-large-4__dash" style={{ color: barColor }}>
          &mdash;
        </span>
        <div className="square-number-large-4__copy-wrapper">
          {header && header.length ? (
            <div
              className="square-number-large-4__header"
              dangerouslySetInnerHTML={{ __html: header }}
            />
          ) : null}
          <div
            className="square-number-large-4__text"
            dangerouslySetInnerHTML={{ __html: paragraphC24 }}
          />
        </div>
      </section>
    </ArticleCardBase>
  );
};

export default SquareNumberLarge4;
